import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Icon, Tooltip } from '@mui/material'

const MoreVert = ({ links, active = true }) => {
    const dispatch = useDispatch()

    const onClick = (href) => {
        dispatch(push(`/${href}`))
    }

    const getLink = (link) => {
        if (active) {
            return link.href ? onClick(link.href) : link.onClick?.()
        }
        return null
    }

    const formattedLinks = links.map((link) => {
        return link.component ? link.component : (
            <Tooltip title={link.tooltip} placement={link.tooltipPosition || 'bottom'}>
                <Icon
                    key={link.iconName}
                    onClick={e => {
                        e.stopPropagation()
                        getLink(link)
                    }}
                    sx={{ color: link.color, fontSize: '25px', cursor: 'pointer' }}
                    data-cy={link['data-cy']}
                >
                    {link.iconName}
                </Icon>
            </Tooltip>
        )
    })
    return (
        // Once Table and Card components have been removed, this line can be change by :
        // <Stack spacing={1} alignItems={'center'}>
        <div className='right fixed-action-btn horizontal btn-tab-action click-to-toggle'>
            { formattedLinks }
        </div>
    )
}

MoreVert.propTypes = {
    links: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
        onClick: PropTypes.func,
        color: PropTypes.string,
        iconName: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        tooltipPosition: PropTypes.string,
        'data-cy': PropTypes.string,
    })).isRequired,
    active: PropTypes.bool,
}
export default MoreVert